module.exports = "query {\n    getMyConnectedSocialMedia {\n        vkontakte\n        facebook\n        telegram\n        email\n    }\n}\n"